import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator, type Meta } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { AccountsBalancesHistoryPageProps } from './accountsBalancesHistoryTypes';

type AccountsBalancesHistoryPayload = QcsSyncResourcesPayload<AccountsBalancesHistoryPageProps>;
type AccountsBalancesHistoryMeta = Meta<AccountsBalancesHistoryPageProps>;

const getRequestPayloadCreator = (payload?: undefined, meta?: AccountsBalancesHistoryMeta) => ({
  payload,
  meta,
});

export const getAccountsBalancesHistory = createAction('GET_ACCOUNTS_BALANCES_HISTORY', getRequestPayloadCreator);
export const getAccountsBalancesHistorySuccess = createAction(
  'GET_ACCOUNTS_BALANCES_HISTORY_SUCCESS',
  getPayloadCreator<AccountsBalancesHistoryPayload, AccountsBalancesHistoryPageProps>(),
);
export const getAccountsBalancesHistoryFailure = createAction(
  'GET_ACCOUNTS_BALANCES_HISTORY_FAILURE',
  getFailurePayloadCreator<unknown, AccountsBalancesHistoryMeta>(),
);
